<template>
  <app-header />
  <div class="container container--margins">
    <router-view />
  </div>
</template>

<script setup>
import { AppHeader } from '@widgets/header'
</script>
